import React from 'react';
import styled, { css } from 'styled-components';
import { Typography } from 'src/typography';
import { centsToDollars } from 'src/payments/utils';

export type TotalProps = {
  label: string;
  amount: number;
  accented?: boolean;
  icon?: JSX.Element;
  discount?: boolean;
};

export const TotalItem = ({ label, amount, accented, icon, discount }: TotalProps): JSX.Element => (
  <TotalContainer>
    <NameContainer>
      {accented ? <Text weight='bold'>{label.toUpperCase()}:</Text> : <Text>{label}:</Text>}
      {icon}
    </NameContainer>
    <Text weight='bold'>
      {' '}
      {discount && <>-</>} {centsToDollars(amount)}
    </Text>
  </TotalContainer>
);

const TotalContainer = styled.div`
  ${({ theme: { colors } }) => css`
    color: ${colors.grey[30]};
    width: 100%;
    display: flex;
    justify-content: space-between;
  `}
`;

const Text = styled(Typography.Body).attrs({
  size: 'small',
})`
  line-height: 18px;
`;

const NameContainer = styled(Text)`
  display: flex;
  align-items: center;
`;
